import API from 'services/api.js';
import { URL_GET_CLIENT_IDS } from 'services/urls.js'
import { actionSetMessage, actionResetMessages } from 'components/messages/actions.js'
//import { actionFetchWeighersSuccess } from 'components/weighers/actions.js';

export const SET_CLIENT_ID = 'SET_CLIENT_ID'
export const SET_CLIENT_IDS = 'SET_CLIENT_IDS'
export const RESET_CLIENT_IDS = 'RESET_CLIENT_IDS'
export const SET_CLIENT_IDS_LOADED = 'SET_CLIENT_IDS_LOADED'

//actionFetchWeighersSuccess
export const actionSetClientId = (data) => {

	return {
		type: SET_CLIENT_ID,
		data
	}
}

export const actionFetchClientIds = (setClientLoading) => {
	//console.log('actionFetchClientIds()')
	return (dispatch) => {
		dispatch(actionResetMessages())
		const params = {}
		let resp = []
		//console.log('URL_GET_CLIENT_IDS', URL_GET_CLIENT_IDS)
		//console.log('params', params)
		return API.get(URL_GET_CLIENT_IDS, params)
		.then(response => {
			//console.log('actionFetchClientIds() response',response)
			resp = response.data
		})
		.catch(error => {
			console.log('error', error)
			dispatch(actionSetMessage('Error fetching Client ID\'s: ' + error))
		}).then(() => {
			//load previous settings
			//console.log('resp', resp)
			dispatch(actionSetClientIdsLoaded())

			if (resp.length > 0){
				//console.log('debug bbbbbb')
				dispatch(actionFetchClientIdsSuccess(resp))
			}

			const clientId = localStorage.getItem("clientId");
			//console.log('clientId LOCAL', clientId)

			const doesClientItExist =  resp.filter((item)=>{
				return item.ClientID === parseFloat(clientId);
			});

			if (clientId > 0){
				//console.log('doesClientItExist',doesClientItExist)
				if (doesClientItExist.length > 0){//only set previous default it it exists in our client list
					//console.log('debug ccccc')
					dispatch(actionSetClientId(clientId))
				} else {//last client loaded is no longer authorized for client
					//console.log('debug eeeee')
					if (resp.length > 0){//	set first item
						dispatch(actionSetClientId(resp[0].ClientID))
						localStorage.setItem("clientId", resp[0].ClientID);//remember for next session
					}
				}
			} else if (resp.length > 0){//	set first item
				//console.log('debug dddd')
				dispatch(actionSetClientId(resp[0].ClientID))
				localStorage.setItem("clientId", resp[0].ClientID);//remember for next session
			}
			setClientLoading(false)
		});
	};
};

export const actionFetchClientIdsSuccess = (data) => {
	return {
		type: SET_CLIENT_IDS,
		data
	}
}

export const actionResetClientIds = () => {
	return {type: RESET_CLIENT_IDS,}
}

export const actionSetClientIdsLoaded = (data) => {
	return {
		type: SET_CLIENT_IDS_LOADED,
	}
}